const themes = {

  default: {
    name: "Sakura",
    logo: "/img/themes/default/logo.png",
    favicon: "/img/themes/default/favicon.ico",
    cssVars: {
      "--primary-color": "#6f42c1",
      "--accent-color": "#a072ee",
      "--bg-color": "#0a0800",
      "--header-bg": `linear-gradient(90.64deg, #1C1D2C 1.63%, #181C3E 99.76%)`,
      "--header-nav-bg": "#2d1a00",
      "--btn-hover-color": "#a072ee",
      "--bg-body": "#000",
      "--landing-body-bg-layout": "#000",
      "--btn-langue-bg": "white",
      "--footer-bg-color": "#ffffff1b",
      "--games-table-bg": "#0b1420"
    },
  },

  sakura: {
    name: "Sakura",
    logo: "/img/themes/default/logo.png",
    favicon: "/img/themes/default/favicon.ico",
    cssVars: {
      "--primary-color": "#6f42c1",
      "--accent-color": "#a072ee",
      "--bg-color": "#0a0800",
      "--header-bg": `linear-gradient(90.64deg, #1C1D2C 1.63%, #181C3E 99.76%)`,
      "--header-nav-bg": "#2d1a00",
      "--btn-hover-color": "#a072ee",
      "--bg-body": "#000",
      "--landing-body-bg-layout": "#000",
      "--btn-langue-bg": "white",
      "--footer-bg-color": "#ffffff1b",
      "--games-table-bg": "#0b1420"
    },
  },
};




export const getTheme = () => {
  const brand = process.env.REACT_APP_BRAND || "default";
  return themes[brand] || themes.default;
};